namespace $ {
	
	export let $giper_lingua_langs = {
        af: "Afrikaans",
        ar: "Arabic",
        bn: "Bengali",
        zh: "Chinese",
        en: "English",
        fr: "French",
        de: "German",
        el: "Greek",
        is: "Icelandic",
        id: "Indonesian",
        it: "Italian",
        ja: "Japanese",
        ko: "Korean",
        lv: "Latvian",
        mr: "Marathi",
        ne: "Nepali",
        pl: "Polish",
        pa: "Panjabi",
        ru: "Russian",
        es: "Spanish",
        sw: "Swahili",
        te: "Telugu",
        th: "Thai",
        tr: "Turkish",
        uk: "Ukrainian",
        ur: "Urdu",
        cy: "Welsh",
    }
	
}
